// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__s1B1n","inputWrap":"Table_inputWrap__3K_SY","col":"Table_col__3NYTv","bmiTooltip":"Table_bmiTooltip__2mAmO"};